import { RefObject, useEffect } from "react";

/** A hook to catch when a click or touch occurs outside of an element*/
export default function useOutsideCallback<T extends Node>(
  /** The reference to the element the callback listens for events outside of*/
  ref: RefObject<T> | null,
  /** The handler to call when an event outside the element occurs */
  handler: (event: MouseEvent | TouchEvent) => void) {
  useEffect(() => {
    function listener(event: globalThis.MouseEvent | globalThis.TouchEvent) {
      if (!ref || !ref.current) {
        return;
      }
      // composedPath is captured when the event is dispatched, so it still
      // shows where the event originated even if a React re-render detached
      // the target from the DOM mid-dispatch (contains() would then be false
      // for a click that really started inside the element).
      if (event.composedPath().includes(ref.current)) {
        return;
      }
      if (ref.current.contains(event.target as Node)) {
        return;
      }
      handler(event);
    }

    document.addEventListener("click", listener);
    document.addEventListener("touchstart", listener)

    return () => {
      document.removeEventListener("click", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}
